var $744d2dad838f829a$exports = {};
// Storage - Handles localStorage persistence
if (window.__debug__) console.debug("Storage loading...");
const $744d2dad838f829a$var$Storage = {
    keys: {
        currentGame: "sudoku_current_game",
        preferences: "sudoku_preferences",
        stats: "sudoku_stats"
    },
    // Save current game state
    saveGame (gameState) {
        try {
            localStorage.setItem(this.keys.currentGame, JSON.stringify(gameState));
            return true;
        } catch (e) {
            if (window.__debug__) console.error("Failed to save game:", e);
            return false;
        }
    },
    // Load current game state
    loadGame () {
        try {
            const data = localStorage.getItem(this.keys.currentGame);
            return data ? JSON.parse(data) : null;
        } catch (e) {
            if (window.__debug__) console.error("Failed to load game:", e);
            return null;
        }
    },
    // Clear current game
    clearGame () {
        try {
            localStorage.removeItem(this.keys.currentGame);
            return true;
        } catch (e) {
            if (window.__debug__) console.error("Failed to clear game:", e);
            return false;
        }
    },
    // Save preferences
    savePreferences (prefs) {
        try {
            localStorage.setItem(this.keys.preferences, JSON.stringify(prefs));
            return true;
        } catch (e) {
            if (window.__debug__) console.error("Failed to save preferences:", e);
            return false;
        }
    },
    // Load preferences
    loadPreferences () {
        try {
            const data = localStorage.getItem(this.keys.preferences);
            return data ? JSON.parse(data) : {
                timerEnabled: true,
                hintsEnabled: true,
                numberHighlightEnabled: true
            };
        } catch (e) {
            if (window.__debug__) console.error("Failed to load preferences:", e);
            return {
                timerEnabled: true,
                hintsEnabled: true,
                numberHighlightEnabled: true
            };
        }
    },
    // Save statistics
    saveStats (stats) {
        try {
            localStorage.setItem(this.keys.stats, JSON.stringify(stats));
            return true;
        } catch (e) {
            if (window.__debug__) console.error("Failed to save stats:", e);
            return false;
        }
    },
    // Load statistics
    loadStats () {
        try {
            const data = localStorage.getItem(this.keys.stats);
            return data ? JSON.parse(data) : this.getDefaultStats();
        } catch (e) {
            if (window.__debug__) console.error("Failed to load stats:", e);
            return this.getDefaultStats();
        }
    },
    // Get default stats structure
    getDefaultStats () {
        return {
            easy: {
                completed: 0,
                attempts: 0,
                bestTime: null
            },
            medium: {
                completed: 0,
                attempts: 0,
                bestTime: null
            },
            hard: {
                completed: 0,
                attempts: 0,
                bestTime: null
            },
            expert: {
                completed: 0,
                attempts: 0,
                bestTime: null
            }
        };
    },
    // Update stats after completing a puzzle
    updateStats (difficulty, time) {
        const stats = this.loadStats();
        // Ensure backwards compatibility with old stats format
        if (!stats[difficulty].hasOwnProperty("attempts")) stats[difficulty].attempts = stats[difficulty].completed || 0;
        stats[difficulty].completed++;
        stats[difficulty].attempts++;
        // Only update best time if timer was enabled (time > 0)
        if (time > 0 && (!stats[difficulty].bestTime || time < stats[difficulty].bestTime)) stats[difficulty].bestTime = time;
        this.saveStats(stats);
        return stats;
    },
    // Track when a game is started (for success rate calculation)
    incrementAttempts (difficulty) {
        const stats = this.loadStats();
        // Ensure backwards compatibility
        if (!stats[difficulty].hasOwnProperty("attempts")) stats[difficulty].attempts = stats[difficulty].completed || 0;
        stats[difficulty].attempts++;
        this.saveStats(stats);
        return stats;
    },
    // Clear all data
    clearAll () {
        try {
            localStorage.removeItem(this.keys.currentGame);
            localStorage.removeItem(this.keys.preferences);
            localStorage.removeItem(this.keys.stats);
            return true;
        } catch (e) {
            if (window.__debug__) console.error("Failed to clear data:", e);
            return false;
        }
    }
};
window.Storage = $744d2dad838f829a$var$Storage;
if (window.__debug__) console.debug("Storage exported to window");


//# sourceMappingURL=repo.8862009c.js.map
